module.exports = __webpack_public_path__ + "2360f2973dc5f80a4e49f9450d3bcff5.png";